import { createContext, useContext, useMemo, useState } from 'react';

const Context = createContext();

export const useShapefileContext = () => useContext(Context);

export function Provider({ children }) {
  const [isFiltering, setFiltering] = useState(false);
  const [filters, setFilters] = useState([]);

  const state = useMemo(
    () => ({ isFiltering, setFiltering, filters, setFilters }),
    [isFiltering, filters],
  );

  return <Context.Provider value={state}>{children}</Context.Provider>;
}
